/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=07d63aa4"
import script from "./EventsTable.ts?vue&type=script&lang=ts&external"
export * from "./EventsTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports